import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { EEventType } from '../../types/events';
import { ESocialType } from '../../types/social';
import { EAuthenticateStatus } from '../../types/mrOAuth';
import { MR_OAUTH_AUTHENTICATE_TYPE } from '../../constants/action_types';
import { authenticateEmailRequired as socialAuthenticateEmailRequired, authenticate as socialAuthenticate } from '../social';
import { mrOAuthAuthenticate, EMROAuthAuthenticateStatus } from '../../api/mrOAuthAuthenticate';
export function authenticate(parameters) {
  var email = parameters.email,
    accessToken = parameters.accessToken;
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(dispatch, getState, context) {
      var source;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            dispatch({
              type: MR_OAUTH_AUTHENTICATE_TYPE,
              status: EAuthenticateStatus.Loading
            });
            source = getState().source;
            _context.next = 4;
            return mrOAuthAuthenticate(context.httpApi, {
              email: email,
              accessToken: accessToken
            }).then(function (response) {
              if (response.statusCode === 200) {
                switch (response.response.data.status) {
                  case EMROAuthAuthenticateStatus.Success:
                    {
                      dispatch({
                        type: MR_OAUTH_AUTHENTICATE_TYPE,
                        status: EAuthenticateStatus.Succeed
                      });
                      var _response$response$da = response.response.data,
                        socialLoginId = _response$response$da.socialLoginId,
                        _email = _response$response$da.email,
                        token = _response$response$da.token;
                      dispatch(socialAuthenticate({
                        socialType: ESocialType.MailRu,
                        socialLoginId: socialLoginId,
                        email: _email,
                        token: token,
                        source: source
                      }));
                      break;
                    }
                  case EMROAuthAuthenticateStatus.UserNotFound:
                    {
                      dispatch({
                        type: MR_OAUTH_AUTHENTICATE_TYPE,
                        status: EAuthenticateStatus.Succeed
                      });
                      var _response$response$da2 = response.response.data,
                        _socialLoginId = _response$response$da2.socialLoginId,
                        _email2 = _response$response$da2.email,
                        phone = _response$response$da2.phone;
                      dispatch(socialAuthenticateEmailRequired({
                        socialType: ESocialType.MailRu,
                        socialLoginId: _socialLoginId,
                        email: _email2,
                        phone: phone
                      }));
                      context.emitter.emit(EEventType.MROAuthActionRequired);
                      break;
                    }
                  default:
                    throw new Error('Unexpected Mail.Ru OAuth Status');
                }
                return;
              }
              var error = response.response.data.error;
              dispatch({
                type: MR_OAUTH_AUTHENTICATE_TYPE,
                status: EAuthenticateStatus.Failed,
                error: error
              });
            }).catch(function (error) {
              context.logger.error(error, {
                domain: 'auth-widget.api.mrOAuth'
              });
              dispatch({
                type: MR_OAUTH_AUTHENTICATE_TYPE,
                status: EAuthenticateStatus.Failed,
                error: 'Произошла непредвиденная ошибка'
              });
            });
          case 4:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function (_x, _x2, _x3) {
      return _ref.apply(this, arguments);
    };
  }();
}